import axios from 'axios'

import {getCookie} from '../helpers'
let token = getCookie('accessToken')

export const api = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL || ''}/api/v1/graphql`,
    headers: {
        'Authorization': token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
    },
    timeout: 40000
})

